import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortByDateKey' })
export class SortByDateKeyPipe implements PipeTransform {
  transform(runs: any[], dateKey: string): any[] {
    return runs.sort((a, b) => new Date(b[dateKey]).valueOf() - new Date(a[dateKey]).valueOf());
  }
}
